import { useQuery } from '@tanstack/react-query';

import * as projectsApi from '~/services/api/projects';

import type { DocumentType, ProjectDocument } from '~/types';

export function useDocumentContent(
  projectId: string | null,
  documentType: DocumentType,
  enabled: boolean,
): {
  content: ProjectDocument | null;
  error: unknown;
  isLoading: boolean;
  refetch: () => Promise<unknown>;
} {
  const {
    data: content,
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ['document', projectId, documentType],
    queryFn: () => (projectId ? projectsApi.getDocumentContent(projectId, documentType) : null),
    enabled: enabled && !!projectId,
    staleTime: 30_000,
  });

  return {
    content: content ?? null,
    isLoading,
    error,
    refetch,
  };
}
